(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffret-decouverte"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ncl-coffret-picker')) {
  customElements.define('ncl-coffret-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choices = [...this.querySelectorAll('[data-choice]')].map(card => ({card,id:card.dataset.id,name:card.dataset.name,price:Number(card.dataset.price),max:Number(card.dataset.max),quantity:0}));
      this.money = new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.choices.forEach(choice => {
        choice.card.querySelector('[data-plus]')?.addEventListener('click', () => this.change(choice, 1));
        choice.card.querySelector('[data-minus]')?.addEventListener('click', () => this.change(choice, -1));
      });
      this.querySelector('form').addEventListener('submit', event => this.addToCart(event));
      this.initScene();
      this.render();
    }
    initScene() {
      this.scene = this.querySelector('.ncl-box-canvas');
      const gl = this.scene?.getContext('webgl', {alpha:true,antialias:true,premultipliedAlpha:false});
      if (!gl) { this.scene?.parentElement.setAttribute('hidden',''); return; }
      this.sceneContext=gl;this.boxSlots=[null,null,null];this.sceneTextures=new Map();
      this.reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
      const vertex=`attribute vec3 aPosition;attribute vec3 aNormal;attribute vec2 aUv;
        uniform vec2 uScale;uniform vec3 uOffset;varying vec3 vPosition;varying vec3 vNormal;varying vec2 vUv;
        void main(){vec3 p=aPosition+uOffset;vPosition=p;vNormal=aNormal;vUv=aUv;
          float x=p.x*.985-p.z*(-.174);float z=p.x*(-.174)+p.z*.985;
          float y=p.y*.643-z*.766;float depth=p.y*.766+z*.643;
          gl_Position=vec4(x*uScale.x,(y-90.)*uScale.y,-depth/900.,1.);}`;
      const fragment=`
        #ifdef GL_FRAGMENT_PRECISION_HIGH
        precision highp float;
        #else
        precision mediump float;
        #endif
        varying vec3 vPosition;varying vec3 vNormal;varying vec2 vUv;
        uniform vec4 uUvTransform;uniform vec4 uColor;uniform float uMaterial;uniform float uTextured;uniform float uKraft;uniform sampler2D uImage;uniform vec3 uOccupied;
        float noise(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233)))*43758.5453);}
        float paperHash(vec2 p){vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}
        float paperNoise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(paperHash(i),paperHash(i+vec2(1.,0.)),f.x),mix(paperHash(i+vec2(0.,1.)),paperHash(i+vec2(1.,1.)),f.x),f.y);}
        void main(){if(uMaterial>5.5){if(distance(vPosition.xz,vec2(-57.,62.))<13.||distance(vPosition.xz,vec2(57.,-62.))<13.)discard;}vec3 n=normalize(vNormal);vec3 c=uColor.rgb;float alpha=uColor.a;
          if(uTextured>0.5){vec4 tex=texture2D(uImage,vUv*uUvTransform.xy+uUvTransform.zw);c*=tex.rgb;alpha*=tex.a;}
          float light=.69+.31*max(0.,dot(n,normalize(vec3(-.5,1.,.7))));
          if(uKraft>.5&&uMaterial!=4.){
            vec3 an=abs(n);vec2 paper=an.y>.65?vPosition.xz:(an.z>an.x?vPosition.xy:vPosition.zy);
            float cloud=paperNoise(paper*.045),fine=paperNoise(paper*2.8);
            float fibers=paperNoise(paper*vec2(.48,4.6));
            float flecks=pow(paperNoise(paper*5.2),5.);
            c*=.945+.025*cloud+.045*fine-.04*smoothstep(.63,.9,fibers)-.06*flecks;
            c+=vec3(.018,.016,.009)*(cloud-.5);
            vec2 bump=vec2(paperNoise((paper+vec2(.18,0.))*2.8)-fine,paperNoise((paper+vec2(0.,.18))*2.8)-fine);
            vec3 tangent=an.y>.65?vec3(1.,0.,0.):(an.z>an.x?vec3(1.,0.,0.):vec3(0.,0.,1.));
            vec3 bitangent=normalize(cross(n,tangent));
            vec3 paperNormal=normalize(n+tangent*bump.x*.14+bitangent*bump.y*.14);
            light=.78+.24*max(0.,dot(paperNormal,normalize(vec3(-.5,1.,.7))));
            if(uMaterial>5.5&&n.y>.6){
              float border=min(174.-abs(vPosition.x),62.-abs(vPosition.z));
              c*=.82+.18*smoothstep(0.,7.,border);
              float d0=length(vPosition.xz-vec2(-114.,0.))-48.;
              float d1=length(vPosition.xz)-48.;float d2=length(vPosition.xz-vec2(114.,0.))-48.;
              float holeEdge=min(abs(d0),min(abs(d1),abs(d2)));
              c*=1.-.14*exp(-holeEdge*holeEdge/1.8);
              float contact=uOccupied.x*exp(-d0*d0/14.)+uOccupied.y*exp(-d1*d1/14.)+uOccupied.z*exp(-d2*d2/14.);
              c*=1.-.14*min(1.,contact);
              c+=vec3(.04,.033,.024)*exp(-pow(holeEdge-1.4,2.)/1.2);
            }
            if(vPosition.y<129.&&abs(vPosition.z)>64.&&abs(n.z)>.8){
              float seam=min(181.-abs(vPosition.x),min(vPosition.y,128.-vPosition.y));
              c*=.88+.12*smoothstep(0.,6.,seam);
              c+=vec3(.035,.03,.022)*exp(-pow(vPosition.y-126.7,2.)/1.4);
              if(vPosition.z<0.&&n.z>0.)c*=.91+.09*smoothstep(122.,137.,vPosition.y);
            }
            if(vPosition.y>128.&&vPosition.z< -67.){
              float fold=exp(-pow((vPosition.y-132.5)/1.5,2.));
              c*=1.-.17*fold;
              c+=vec3(.032,.027,.018)*exp(-pow((vPosition.y-135.)/1.2,2.));
              c*=.95+.05*smoothstep(128.,149.,vPosition.y);
            }
            if(n.y>.8&&vPosition.y>127.5&&vPosition.y<128.5&&vPosition.z>65.){
              float flute=.5+.5*sin(vPosition.x*2.24);
              c*=.82+.18*flute;c+=vec3(.028,.022,.014);
            }
          }
          if(uMaterial>1.5&&uMaterial<2.5){float s=pow(max(0.,dot(n,normalize(vec3(-.34,.4,1.)))),32.);c+=vec3(.22,.19,.15)*s;}
          if(uMaterial>2.5&&uMaterial<3.5){float grain=noise(vPosition.xz*5.+vPosition.xy*4.);c*=.78+grain*.4;}
          if(uMaterial>3.5&&uMaterial<4.5){float d=length(vUv*2.-1.);alpha*=exp(-d*d*3.4)*smoothstep(1.,.62,d);light=1.;}
          if(uMaterial>4.5&&uMaterial<5.5){float shadow=0.;shadow+=uOccupied.x*exp(-dot(vPosition.xz-vec2(-114.,0.),vPosition.xz-vec2(-114.,0.))/2100.);shadow+=uOccupied.y*exp(-dot(vPosition.xz,vPosition.xz)/2100.);shadow+=uOccupied.z*exp(-dot(vPosition.xz-vec2(114.,0.),vPosition.xz-vec2(114.,0.))/2100.);c*=1.-min(.3,shadow*.3);float edge=min(177.-abs(vPosition.x),62.-abs(vPosition.z));c*=.85+.15*smoothstep(0.,22.,edge);c*=.98+noise(vPosition.xz*4.)*.04;}
          gl_FragColor=vec4(c*light,alpha);}`;
      const compile=(type,source)=>{const shader=gl.createShader(type);gl.shaderSource(shader,source);gl.compileShader(shader);if(!gl.getShaderParameter(shader,gl.COMPILE_STATUS))throw Error(gl.getShaderInfoLog(shader));return shader;};
      try {
        const program=gl.createProgram();gl.attachShader(program,compile(gl.VERTEX_SHADER,vertex));gl.attachShader(program,compile(gl.FRAGMENT_SHADER,fragment));gl.linkProgram(program);
        if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Scene program');gl.useProgram(program);this.sceneProgram=program;
        this.sceneUniforms=Object.fromEntries(['uUvTransform','uScale','uOffset','uColor','uMaterial','uTextured','uKraft','uImage','uOccupied'].map(n=>[n,gl.getUniformLocation(program,n)]));
        this.sceneAttributes=['aPosition','aNormal','aUv'].map(n=>gl.getAttribLocation(program,n));
        this.sceneMeshes=[];this.buildScene();
        this.loadSceneTexture('box-logo','https://nucellina.fr/cdn/shop/files/LOGO_NUCELLINA_3.png?v=1771771608');
        if(this.dataset.sceneHeartUrl)this.loadSceneTexture('box-heart',this.dataset.sceneHeartUrl);
        this.choices.forEach(c=>{if(c.card.dataset.sceneFront)this.loadSceneTexture(c.id+':front',c.card.dataset.sceneFront);if(c.card.dataset.sceneLid)this.loadSceneTexture(c.id+':lid',c.card.dataset.sceneLid);});
        this.sceneObserver=new ResizeObserver(()=>this.drawScene());this.sceneObserver.observe(this.scene);this.drawScene();
      } catch(error){this.sceneContext=null;this.scene.parentElement.hidden=true;}
    }
    disconnectedCallback() {
      if (this.sceneFrame) cancelAnimationFrame(this.sceneFrame);
      this.sceneObserver?.disconnect();
    }
    syncScene() {
      if (!this.sceneContext) return;
      const signature = this.choices.map(c => `${c.id}:${c.quantity}`).join('|');
      if (signature === this.sceneSignature) return;
      this.sceneSignature = signature;
      const remaining = new Map(this.choices.map(c => [c.id,c.quantity]));
      const now = performance.now();
      this.boxSlots.forEach(slot => {
        if (!slot || slot.target === 0) return;
        if ((remaining.get(slot.id) || 0) > 0) remaining.set(slot.id, remaining.get(slot.id) - 1);
        else { slot.from = slot.level; slot.target = 0; slot.started = now; }
      });
      this.choices.forEach(choice => {
        for(let i=0;i<(remaining.get(choice.id) || 0);i++) {
          const index = this.boxSlots.findIndex(slot => !slot || slot.target === 0);
          if (index < 0) break;
          this.boxSlots[index] = {id:choice.id,name:choice.name,level:0,from:0,target:1,started:now};
        }
      });
      const names = this.boxSlots.filter(s => s?.target === 1).map(s => s.name);
      this.scene.setAttribute('aria-label', names.length ? `${this.dataset.sceneFilled} ${names.join(', ')}` : this.dataset.sceneEmpty);
      this.querySelector('.ncl-box-count').textContent = `${names.length} / 3`;
      if (this.reducedMotion.matches) {
        this.boxSlots = this.boxSlots.map(slot => slot?.target === 1 ? {...slot,level:1} : null);
        this.drawScene();
      } else if (!this.sceneFrame) this.sceneFrame = requestAnimationFrame(time => this.animateScene(time));
    }
    animateScene(time) {
      this.sceneFrame = 0;
      let running = false;
      this.boxSlots = this.boxSlots.map(slot => {
        if (!slot) return null;
        const t = Math.min(1, Math.max(0, (time-slot.started)/680));
        const eased = 1-Math.pow(1-t,3);
        slot.level = slot.from + (slot.target-slot.from)*eased;
        if (t<1) running = true;
        if (t===1 && slot.target===0) return null;
        return slot;
      });
      this.drawScene();
      if (running && this.isConnected) this.sceneFrame = requestAnimationFrame(t => this.animateScene(t));
    }
    loadSceneTexture(key,url) {
      const image=new Image();image.crossOrigin='anonymous';image.onload=()=>{const gl=this.sceneContext;if(!gl||gl.isContextLost())return;const texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,image);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);this.sceneTextures.set(key,texture);this.drawScene();};image.src=url;
    }
    sceneMesh(vertices,color,material=0,texture=null,slot=-1) {
      const gl=this.sceneContext,buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(vertices),gl.STATIC_DRAW);
      const hex=color.replace('#','');const rgb=[0,2,4].map(i=>parseInt(hex.slice(i,i+2),16)/255);
      this.sceneMeshes.push({buffer,count:vertices.length/8,color:rgb,material,texture,slot});
    }
    buildScene() {
      const tri=(out,p,n,uv)=>p.forEach((v,i)=>out.push(...v,...(Array.isArray(n[0])?n[i]:n),...uv[i]));
      const quad=(p,color,material=0,texture=null,slot=-1,n=null)=>{const v=[],a=p[0],b=p[1],c=p[2];if(!n){const u=b.map((x,i)=>x-a[i]),w=c.map((x,i)=>x-a[i]);n=[u[1]*w[2]-u[2]*w[1],u[2]*w[0]-u[0]*w[2],u[0]*w[1]-u[1]*w[0]];}tri(v,[p[0],p[1],p[2]],n,[[0,0],[1,0],[1,1]]);tri(v,[p[0],p[2],p[3]],n,[[0,0],[1,1],[0,1]]);this.sceneMesh(v,color,material,texture,slot);};
      const panel=(x1,x2,y1,y2,z1,z2,color)=>{quad([[x1,y2,z1],[x2,y2,z1],[x2,y2,z2],[x1,y2,z2]],color,0,null,-1,[0,1,0]);quad([[x1,y1,z2],[x2,y1,z2],[x2,y2,z2],[x1,y2,z2]],color,0,null,-1,[0,0,1]);quad([[x2,y1,z1],[x1,y1,z1],[x1,y2,z1],[x2,y2,z1]],color,0,null,-1,[0,0,-1]);quad([[x1,y1,z1],[x1,y1,z2],[x1,y2,z2],[x1,y2,z1]],color,0,null,-1,[-1,0,0]);quad([[x2,y1,z2],[x2,y1,z1],[x2,y2,z1],[x2,y2,z2]],color,0,null,-1,[1,0,0]);};
      const ring=(x,y,outer,inner,color,slot=-1,texture=null)=>{const v=[];for(let j=0;j<96;j++){const a=j*Math.PI/48,b=(j+1)*Math.PI/48;const point=(t,r)=>[x+Math.sin(t)*r,y,Math.cos(t)*r];const uv=p=>texture?[.503+(p[0]-x)/outer*.311,.211+p[2]/outer*.074]:[(p[0]-x)/outer/2+.5,p[2]/outer/2+.5];const p=[point(a,outer),point(b,outer),point(b,inner),point(a,inner)];tri(v,[p[0],p[1],p[2]],[0,1,0],[uv(p[0]),uv(p[1]),uv(p[2])]);tri(v,[p[0],p[2],p[3]],[0,1,0],[uv(p[0]),uv(p[2]),uv(p[3])]);}this.sceneMesh(v,color,texture?1:0,texture,slot);};
      const lathe=(x,profile,color,material,slot=-1,texture=null,front=false)=>{const v=[];for(let k=0;k<profile.length-1;k++){const [y1,r1]=profile[k],[y2,r2]=profile[k+1],slope=(r1-r2)/(y2-y1||1);for(let j=0;j<96;j++){const a=(front?-Math.PI/2:0)+j*(front?Math.PI:2*Math.PI)/96,b=a+(front?Math.PI:2*Math.PI)/96;const p=[[x+Math.sin(a)*r1,y1,Math.cos(a)*r1],[x+Math.sin(b)*r1,y1,Math.cos(b)*r1],[x+Math.sin(b)*r2,y2,Math.cos(b)*r2],[x+Math.sin(a)*r2,y2,Math.cos(a)*r2]];const normals=[[Math.sin(a),slope,Math.cos(a)],[Math.sin(b),slope,Math.cos(b)],[Math.sin(b),slope,Math.cos(b)],[Math.sin(a),slope,Math.cos(a)]];const uv=(t,y)=>[.177+.65*(Math.sin(t)+1)/2,.796-(y-22)/(99-22)*.462];const uvs=[uv(a,y1),uv(b,y1),uv(b,y2),uv(a,y2)];tri(v,[p[0],p[1],p[2]],[normals[0],normals[1],normals[2]],[uvs[0],uvs[1],uvs[2]]);tri(v,[p[0],p[2],p[3]],[normals[0],normals[2],normals[3]],[uvs[0],uvs[2],uvs[3]]);} }this.sceneMesh(v,color,material,texture,slot);};
      quad([[-240,-2,-125],[240,-2,-125],[240,-2,155],[-240,-2,155]],'#493520',4,null,-1,[0,1,0]);
      panel(-181,181,0,6,-67,67,'#bfa785');
      panel(-181,181,0,128,-69,-65,'#bfa785');
      panel(-181,-177,0,128,-65,65,'#c8b493');panel(177,181,0,128,-65,65,'#c3ae8d');
      panel(-181,181,0,128,65,69,'#c3ad8b');
      quad([[-177,12,-63],[177,12,-63],[177,12,63],[-177,12,63]],'#d8bd91',5,null,-1,[0,1,0]);
      quad([[-178,128,-68],[178,128,-68],[172,220,-129],[-172,220,-129]],'#cebea2',0,null,-1,[0,.552,.834]);
      quad([[-178,128,-71],[-172,220,-132],[172,220,-132],[178,128,-71]],'#ae9878',0,null,-1,[0,-.552,-.834]);
      quad([[-172,220,-129],[172,220,-129],[172,220,-132],[-172,220,-132]],'#ddceb2',0,null,-1,[0,1,0]);
      quad([[-178,128,-68],[-172,220,-129],[-172,220,-132],[-178,128,-71]],'#ae9878');
      quad([[178,128,-68],[178,128,-71],[172,220,-132],[172,220,-129]],'#ae9878');
      quad([[-173,133,-71],[173,133,-71],[173,134,-71.7],[-173,134,-71.7]],'#a99171',0,null,-1,[0,.55,.84]);
      quad([[-181,128,-65],[-181,128,60],[-194,137,50],[-199,146,-44]],'#ceba99',0,null,-1,[-.2,1,0]);
      quad([[181,128,-65],[199,146,-44],[194,137,50],[181,128,60]],'#ceba99',0,null,-1,[.2,1,0]);
      for(let x=-176;x<178;x+=2.8){quad([[x,128.07999999999998,65.2],[x+1.3,128.07999999999998,65.2],[x+1.3,128.07999999999998,68.7],[x,128.07999999999998,68.7]],'#ac9574',0,null,-1,[0,1,0]);}
      for(let cell=0;cell<3;cell++){
        const cx=[-114,0,114][cell],left=cell===0?-174:cx-57,right=cell===2?174:cx+57,vertices=[],edgeVertices=[];
        const outer=a=>{
          const dx=Math.sin(a),dz=Math.cos(a),tx=Math.abs(dx)<.00001?Infinity:(dx>0?right-cx:left-cx)/dx,tz=62/Math.max(.00001,Math.abs(dz));
          const t=Math.min(tx,tz);let x=cx+dx*t,z=dz*t;
          if(Math.abs(z)>61.99){
            if(Math.abs(x)>166)z=Math.sign(z)*Math.min(Math.abs(z),228-Math.abs(x));
          }
          return [x,122,z];
        };
        const uv=p=>[(p[0]+174)/348,(p[2]+62)/124];
        for(let j=0;j<192;j++){
          const a=j*Math.PI/96,b=(j+1)*Math.PI/96,oa=outer(a),ob=outer(b),ia=[cx+Math.sin(a)*48,122,Math.cos(a)*48],ib=[cx+Math.sin(b)*48,122,Math.cos(b)*48];
          tri(vertices,[oa,ob,ib],[0,1,0],[uv(oa),uv(ob),uv(ib)]);tri(vertices,[oa,ib,ia],[0,1,0],[uv(oa),uv(ib),uv(ia)]);
          const lowA=[ia[0],118.5,ia[2]],lowB=[ib[0],118.5,ib[2]],normal=[-Math.sin((a+b)/2),0,-Math.cos((a+b)/2)];
          tri(edgeVertices,[ia,ib,lowB],normal,[[0,0],[1,0],[1,1]]);tri(edgeVertices,[ia,lowB,lowA],normal,[[0,0],[1,1],[0,1]]);
          const outerLowA=[oa[0],118.5,oa[2]],outerLowB=[ob[0],118.5,ob[2]];
          tri(edgeVertices,[oa,outerLowA,outerLowB],[Math.sin((a+b)/2),0,Math.cos((a+b)/2)],[[0,0],[0,1],[1,1]]);tri(edgeVertices,[oa,outerLowB,ob],[Math.sin((a+b)/2),0,Math.cos((a+b)/2)],[[0,0],[1,1],[1,0]]);
        }
        this.sceneMesh(vertices,'#d4c8ae',6);this.sceneMesh(edgeVertices,'#b19d7e',6);
      }
      for(const [nx,nz,angle] of [[-57,62,Math.PI/2],[57,-62,-Math.PI/2]]){
        for(let j=0;j<48;j++){
          const a=angle+j*Math.PI/48,b=a+Math.PI/48,pa=[nx+Math.sin(a)*13,122,nz+Math.cos(a)*13],pb=[nx+Math.sin(b)*13,122,nz+Math.cos(b)*13];
          quad([pa,pb,[pb[0],118.5,pb[2]],[pa[0],118.5,pa[2]]],'#b19d7e',0,null,-1,[-Math.sin((a+b)/2),0,-Math.cos((a+b)/2)]);
        }
      }
      for(let i=0;i<3;i++){
        const x=[-114,0,114][i];ring(x,12.15,45,0,'#92734e');ring(x,12.19,39,0,'#a88960');ring(x,12.25,46,43.5,'#ead4af');ring(x,12.3,43.5,41.8,'#ad895d');
        lathe(x,[[12.5,37],[14,40],[17,42],[21,43],[101,43],[104,44],[107,46],[110,46],[112,42],[119,42]],'#794525',2,i);
        lathe(x,[[14,39.2],[15.3,41],[17,42]],'#8b7253',2,i);
        lathe(x,[[22,43.1],[99,43.1]],'#e8d8b5',1,i);
        lathe(x,[[22,43.22],[99,43.22]],'#ffffff',1,i,'front',true);
        lathe(x,[[118,43],[119,46],[123,47],[131,47],[134,45],[135,41]],'#563235',3,i);
        lathe(x,[[121,47.1],[122,47.1]],'#352629',2,i);
        ring(x,135.1,41.1,0,'#573536',i);ring(x,135.18,41.1,0,'#ffffff',i,'lid');
        quad([[x-4,99,43.6],[x+4,99,43.6],[x+4,119,43.6],[x-4,119,43.6]],'#ef3340',1,null,i,[0,0,1]);
      }

      const logoVertices=[],logoPoints=[[-65,54.5,69.2],[65,54.5,69.2],[65,22,69.2],[-65,22,69.2]],logoUv=[[.13,.28],[.87,.28],[.87,.60],[.13,.60]];
      tri(logoVertices,[logoPoints[0],logoPoints[1],logoPoints[2]],[0,0,1],[logoUv[0],logoUv[1],logoUv[2]]);
      tri(logoVertices,[logoPoints[0],logoPoints[2],logoPoints[3]],[0,0,1],[logoUv[0],logoUv[2],logoUv[3]]);
      this.sceneMesh(logoVertices,'#ffffff',1,'box-logo');
      quad([[-26,196,-112.68],[26,196,-112.68],[26,152,-83.71],[-26,152,-83.71]],'#ffffff',1,'box-heart',-1,[0,.552,.834]);

    }
    drawScene() {
      const gl=this.sceneContext;if(!gl||!this.sceneProgram||gl.isContextLost())return;const rect=this.scene.getBoundingClientRect();if(!rect.width||!rect.height)return;
      const ratio=Math.min(window.devicePixelRatio||1,2);if(this.scene.width!==Math.round(rect.width*ratio)||this.scene.height!==Math.round(rect.height*ratio)){this.scene.width=Math.round(rect.width*ratio);this.scene.height=Math.round(rect.height*ratio);}gl.viewport(0,0,this.scene.width,this.scene.height);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.enable(gl.DEPTH_TEST);gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);gl.useProgram(this.sceneProgram);
      const u=this.sceneUniforms,unit=Math.min(rect.width/440,rect.height/340);gl.uniform2f(u.uScale,2*unit/rect.width,2*unit/rect.height);gl.uniform3fv(u.uOccupied,this.boxSlots.map(s=>s?.level||0));gl.uniform1i(u.uImage,0);
      this.sceneMeshes.forEach(mesh=>{const slot=mesh.slot>=0?this.boxSlots[mesh.slot]:null;if(mesh.slot>=0&&!slot)return;const alpha=slot?Math.min(1,slot.level*3):1;if(alpha<=0)return;
        const key=mesh.texture==='front'||mesh.texture==='lid'?slot.id+':'+mesh.texture:mesh.texture;const texture=key&&this.sceneTextures.get(key);if(mesh.texture&&!texture)return;
        const lidCrop=mesh.texture==='lid'?this.choices.find(c=>c.id===slot.id)?.card.dataset.sceneLidCrop:null;
        if(lidCrop){const [cx,cy,rx,ry]=lidCrop.split(',').map(Number);const sx=rx/.311,sy=ry/.074;gl.uniform4f(u.uUvTransform,sx,sy,cx-.503*sx,cy-.211*sy);}else gl.uniform4f(u.uUvTransform,1,1,0,0);
        gl.uniform3f(u.uOffset,0,slot?(1-slot.level)*175:0,0);gl.uniform4f(u.uColor,...mesh.color,mesh.material===4?.36:alpha);gl.uniform1f(u.uMaterial,mesh.material);gl.uniform1f(u.uKraft,mesh.slot<0?1:0);gl.uniform1f(u.uTextured,texture?1:0);gl.bindTexture(gl.TEXTURE_2D,texture||null);gl.bindBuffer(gl.ARRAY_BUFFER,mesh.buffer);
        this.sceneAttributes.forEach((a,i)=>{gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,i===2?2:3,gl.FLOAT,false,32,i===0?0:i===1?12:24);});gl.depthMask(mesh.material!==4);gl.drawArrays(gl.TRIANGLES,0,mesh.count);
      });gl.depthMask(true);
    }
    count() { return this.choices.reduce((sum,c) => sum + c.quantity, 0); }
    change(choice, delta) {
      if (this.submitting || this.uncertain) return;
      if (delta > 0 && (this.count() >= 3 || choice.quantity >= choice.max)) return;
      choice.quantity = Math.max(0, Math.min(choice.max, choice.quantity + delta));
      this.querySelector('.ncl-picker-status').textContent = '';
      this.render();
    }
    render() {
      this.syncScene();
      const count = this.count();
      const locked = this.submitting || this.uncertain;
      const total = this.choices.reduce((sum,c) => sum + c.quantity * c.price, 0);
      this.querySelector('[data-total]').textContent = this.money.format(total / 100);
      this.querySelector('[data-mobile-total]').textContent = this.money.format(total / 100);
      this.querySelector('[data-mobile-count]').textContent = `${count} / 3 pots`;
      this.querySelector('.ncl-count').textContent = `${count} / 3`;
      this.querySelector('.ncl-selection-hint').textContent = count === 3 ? this.dataset.ready : this.dataset.remaining.replace('[count]', String(3 - count));
      this.querySelector('.ncl-progress span').style.width = `${count / 3 * 100}%`;
      this.querySelector('.ncl-picker-buy').disabled = Boolean(locked || count !== 3);
      const list = this.querySelector('.ncl-selection-list');
      list.replaceChildren();
      this.choices.forEach(choice => {
        const plus = choice.card.querySelector('[data-plus]');
        const minus = choice.card.querySelector('[data-minus]');
        if (plus) plus.disabled = Boolean(locked || count >= 3 || choice.quantity >= choice.max);
        if (minus) minus.disabled = Boolean(locked || choice.quantity <= 0);
        const output = choice.card.querySelector('output');
        if (output) output.textContent = String(choice.quantity);
        choice.card.classList.toggle('is-selected', choice.quantity > 0);
        for (let i=0;i<choice.quantity;i++) {
          const li = document.createElement('li');
          const photo = choice.card.querySelector('img');
          if (photo) { const image = document.createElement('img'); image.src = photo.currentSrc || photo.src; image.alt = ''; li.append(image); }
          const title = document.createElement('span'); title.textContent = choice.name;
          const price = document.createElement('strong'); price.textContent = this.money.format(choice.price / 100);
          li.append(title, price); list.append(li);
        }
      });
      for(let i=count;i<3;i++) {
        const li = document.createElement('li'); li.className = 'ncl-empty';
        const number = document.createElement('span'); number.className = 'ncl-slot-number'; number.textContent = `0${i+1}`;
        const title = document.createElement('span'); title.textContent = this.dataset.empty;
        li.append(number, title); list.append(li);
      }
    }
    async addToCart(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (this.submitting || this.uncertain || this.count() !== 3) return;
      const items = this.choices.filter(c => c.quantity > 0).map(c => ({id:c.id,quantity:c.quantity}));
      if (this.choices.some(c => c.quantity > c.max)) return;
      this.submitting = true; this.render();
      const button = this.querySelector('.ncl-picker-buy');
      const label = button.querySelector('span'); const original = label.textContent;
      label.textContent = this.dataset.loading; button.setAttribute('aria-busy','true');
      const status = this.querySelector('.ncl-picker-status'); status.textContent = '';
      let definiteFailure = false;
      try {
        const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) {
          definiteFailure = response.status >= 400 && response.status < 500;
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.submitting = false; this.uncertain = !definiteFailure;
        status.textContent = definiteFailure ? error.message : this.dataset.network;
        this.querySelector('.ncl-picker-cart').hidden = false;
        label.textContent = original; button.removeAttribute('aria-busy'); this.render();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coffret-invitation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ncl-coffret-photo'))customElements.define('ncl-coffret-photo',class extends HTMLElement{
  connectedCallback(){
    if(this.events)return;
    this.events=new AbortController();
    this.jars=[...this.querySelectorAll('[data-jar]')];
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.elapsed=0;
    this.render(1800);
    this.motion.addEventListener('change',()=>this.sync(),{signal:this.events.signal});
    document.addEventListener('visibilitychange',()=>this.sync(),{signal:this.events.signal});
    this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.2});
    this.observer.observe(this);
    Promise.all([...new Set([...this.querySelectorAll('image')].map(el=>el.getAttribute('href')))].map(url=>new Promise(resolve=>{const img=new Image();img.onload=resolve;img.onerror=resolve;img.src=url;}))).then(()=>{if(!this.isConnected)return;this.ready=true;this.sync();});
  }
  sync(){
    cancelAnimationFrame(this.frame);this.frame=null;this.last=null;
    if(this.motion.matches){this.elapsed=0;this.render(1800);return;}
    if(!this.ready||!this.visible||document.hidden)return;
    const tick=now=>{if(this.last!==null)this.elapsed+=Math.min(60,now-this.last);this.last=now;this.render(this.elapsed%3600);this.frame=requestAnimationFrame(tick);};
    this.frame=requestAnimationFrame(tick);
  }
  render(time){
    this.jars.forEach((jar,i)=>{
      const t=Math.max(0,Math.min(1,(time-120-i*240)/760));
      const ease=1-Math.pow(1-t,3);
      let y=285*ease,opacity=1;
      if(time>2760&&time<3010)opacity=1-(time-2760)/250;
      else if(time>=3010){y=0;opacity=Math.min(1,(time-3160)/300);opacity=Math.max(0,opacity);}
      jar.setAttribute('transform','translate(0 '+y.toFixed(2)+')');
      jar.style.opacity=opacity;
    });
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.events?.abort();this.events=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();

        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
		super();
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
					var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                      	return new bootstrap.Tooltip(tooltipTriggerEl)
                    });
					if (vela.settings.currencies) {
						Currency.convertAll(shopCurrency, $('[name=currencies]').data('value'));
						velaCurrencyCurrent.text(Currency.currentCurrency);
					} 
				}
			})
			.catch(e => {
				console.error(e);
			});
		}
	
		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}
	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
